import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { ProfileFieldWithIcon } from "../../ProfileFieldWithIcon/ProfileFieldWithIcon";
import type { NumberOptions } from "../CustomField/NumberInput";
import type { Field } from "../CustomFieldsList";
import { FieldTypeDisplayInformation } from "./FieldTypeDisplayInformation";
import { FieldTypePreviewInformation } from "./FieldTypePreviewInformation";

export interface UserInformationField extends Field {
  choices: { id: number; value: string }[];
  community_member_profile_field: {
    text: string;
    textarea: string;
    community_member_choices: {
      profile_field_choice: { value: string };
    }[];
  };
  id: number;
  label: string;
  number_options: NumberOptions;
}

interface UserInformationProps {
  fields?: UserInformationField[];
  isHidden?: boolean;
  isPreview?: boolean;
}

export const UserInformation = ({
  fields,
  isPreview,
  isHidden,
}: UserInformationProps) => {
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = isCommunityAdmin(currentCommunityMember);

  return (
    <div className="grid gap-6">
      {fields?.map(field => {
        const { id, label, field_type: fieldType } = field;

        let text =
          FieldTypePreviewInformation[
            fieldType as keyof typeof FieldTypePreviewInformation
          ](field) || null;
        if (!isPreview) {
          text =
            FieldTypeDisplayInformation[
              fieldType as keyof typeof FieldTypeDisplayInformation
            ](field) || null;
          if (isAdmin && text == null) {
            text = (
              <span className="opacity-60">{t("profile_fields.empty")}</span>
            );
          }
        }

        if (!isAdmin && text == null) {
          return null;
        }

        return (
          <ProfileFieldWithIcon
            key={id}
            title={label}
            text={text}
            isHidden={isHidden}
            dataTestId="user-profile-field"
          />
        );
      })}
    </div>
  );
};
